/**
 * Gamayun (ETS filling assistant) address from the `VUE_APP_GAMAYUN_URL` build variable.
 * Without a valid http(s) address the "Гамаюн" button is not rendered.
 */

/**
 * @param {string | undefined} value
 * @returns {URL | null}
 */
const parseGamayunUrl = (value) => {
  if (!value) return null;

  try {
    const url = new URL(value);

    return ['http:', 'https:'].includes(url.protocol) ? url : null;
  } catch {
    return null;
  }
};

/**
 * The only origin ETS UI exchanges messages with.
 *
 * @param {string | undefined} [value] Gamayun address, `VUE_APP_GAMAYUN_URL` by default
 * @returns {string | null} origin or `null` if the address is empty or invalid
 *
 * @example
 * getGamayunOrigin('https://gamayun.example.com/') // returns 'https://gamayun.example.com'
 */
export const getGamayunOrigin = (value = process.env.VUE_APP_GAMAYUN_URL) => {
  const url = parseGamayunUrl(value);

  return url ? url.origin : null;
};

/**
 * Gamayun launch page, `<address>/launch`, without query string and hash.
 *
 * @param {string | undefined} [value] Gamayun address, `VUE_APP_GAMAYUN_URL` by default
 * @returns {string | null} launch page URL or `null` if the address is empty or invalid
 */
export const getGamayunLaunchUrl = (value = process.env.VUE_APP_GAMAYUN_URL) => {
  const url = parseGamayunUrl(value);

  return url ? `${url.origin}${url.pathname.replace(/\/+$/, '')}/launch` : null;
};
